import React from 'react';
import { Section } from './ui/Section';
import { Star } from 'lucide-react';
export function OutcomesSection() {
  const outcomes = ["Pasar de pantallas 'abiertas todo el día' a dos ventanas claras.", 'Tener un protocolo de apagado de 10 minutos que reduce la tensión.', "Sacar pantallas del 'modo escondido' y llevarlas a un sistema de hogar.", 'Volver a ordenar sueño, tareas y convivencia.', 'Recuperar autoridad sin romper el vínculo.'];
  return <Section background="navy" data-id="element-142">
      <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-8 text-center" data-id="element-143">
        Lo que vas a lograr en 30 días
      </h2>

      <div className="space-y-6 max-w-3xl mx-auto" data-id="element-144">
        {outcomes.map((outcome, index) => <div key={index} className="flex items-start gap-4 p-4 rounded-lg hover:bg-white/5 transition-colors" data-id="element-145">
            <Star className="w-6 h-6 text-[#c9a84c] flex-shrink-0 mt-1 fill-[#c9a84c]" data-id="element-146" />
            <p className="text-xl text-gray-200" data-id="element-147">{outcome}</p>
          </div>)}
      </div>

      <div className="mt-8 text-center" data-id="element-148">
        <p className="text-lg text-[#c9a84c] italic font-serif opacity-80" data-id="element-149">
          (No es perfección. Es control. Es paz. Es estructura.)
        </p>
      </div>
    </Section>;
}